<script lang="ts" setup generic="T">
import { TirPmIconView } from "tir-pm-icon-view";
import { PropType, computed, useSlots, defineEmits } from "vue";
import { CrossCompactIcon } from "tir-style-system/icons/outline";
/**
 * Пропсы
 */
const props = defineProps({
  /**
   * Выбираемый
   */
  isSelectable: { type: Boolean as PropType<boolean>, default: false },
  /**
   * Выбранный
   */
  isSelected: { type: Boolean as PropType<boolean>, default: false },
  /**
   * Закрываемый
   */
  isClosable: { type: Boolean as PropType<boolean>, default: false },
  /**
   * Произвольные параметры, передавамые при клике или закрытии
   */
  additionalParams: { type: Object as PropType<T> },
  /**
   * Обводка
   */
  isBordered: { type: Boolean as PropType<boolean>, default: false },
});

const emit = defineEmits<{
  (eventName: "close", value: T): void;
  (eventName: "select", value: T): void;
}>();

// /**
//  * Слоты
//  */
// const slots = useSlots();

/**
 * Стили на основе просов
 */
const computedClasses = computed(() => {
  return {
    "tir-pm-select-badge--selectable": props.isSelectable,
    "tir-pm-select-badge--selected": props.isSelected,
    "tir-pm-select-badge--bordered": props.isBordered,
  };
});

/**
//  * Есть ли слот для IconView
//  */
// const isWithIconViewAddon = computed(() => slots && slots.iconViewAddon && slots.iconViewAddon());
// /**
//  * Есть ли слот для текста
//  */
// const isWithSign = computed(() => slots && slots.sign && slots.sign());

/**
 * Обработчик закрытия с эмитом
 */
const onClose = () => {
  if (props.isClosable) {
    emit("close", props.additionalParams as T);
  }
};

/**
 * Обработчик выбора с эмитом
 */
const onSelect = () => {
  if (props.isSelectable) {
    emit("select", props.additionalParams as T);
  }
};
</script>

<template>
  <div class="tir-pm-select-badge" @click="onSelect" :class="computedClasses">
    <div class="tir-pm-select-badge__icon-view">
      <slot name="iconViewAddon"></slot>
    </div>
    <span class="tir-pm-select-badge__sign">
      <slot name="sign"></slot>
    </span>
    <div class="tir-pm-select-badge__divider" v-if="props.isClosable"></div>
    <div class="tir-pm-select-badge__close-button" v-if="props.isClosable" @click="onClose">
      <CrossCompactIcon></CrossCompactIcon>
    </div>
  </div>
</template>

<style lang="scss">
@import "./style.scss";
</style>
